/* eslint-disable no-plusplus */
// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { ARYABHATTA_API_DOMAIN_V1 } from 'config';
import { DEFAULT_ERROR_MESSAGE } from '../constant';
import axios from 'utils/axios';
import { dispatch } from '../index';
import { openSnackbar } from './snackbar';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    moduleAccess: []
};

const slice = createSlice({
    name: 'moduleAccess',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // setSummaryData
        setData(state, action) {
            const { modules = [] } = action.payload;

            const moduleMap = {};
            for (let i = 0; i < modules.length; i++) {
                moduleMap[modules[i]?.name] = modules[i];
            }

            state.moduleAccessMap = moduleMap;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getModuleAccessData() {
    return async () => {
        try {
            const response = await axios.get(`${ARYABHATTA_API_DOMAIN_V1}module-access/`, {
                headers: {
                    // Authorization: accessToken,
                    source: 'mweb'
                }
            });
            dispatch(slice.actions.setData(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}
